import InertIcon from "./InertIcon";
import DemoAvatar from "./DemoAvatar";
import { resolveDemoIcon } from "../icons/defaultIcons";
import type { InboxDemoIcons, InboxDemoNavigation } from "../data/types";

type TopNavigationProps = {
  icons: InboxDemoIcons;
  navigation?: InboxDemoNavigation;
};

export default function TopNavigation({
  icons,
  navigation,
}: TopNavigationProps) {
  const title = navigation?.title ?? "Inbox";
  const badge = navigation?.planBadge;
  const userName = navigation?.userName ?? "User";

  return (
    <header className="flex h-12 shrink-0 items-center justify-between bg-[var(--inbox-demo-chrome)] pr-6">
      <div className="flex min-w-0 items-center gap-2">
        <InertIcon className="flex h-10 w-10 items-center justify-center rounded-[14px] text-default-600">
          {resolveDemoIcon(icons, "panelLeft")}
        </InertIcon>
        <p className="truncate text-sm leading-5 text-default-800">{title}</p>
      </div>
      <div className="flex items-center justify-end gap-2 text-default-600">
        <span className="relative flex h-10 w-10 items-center justify-center">
          <InertIcon className="text-default-600">
            {resolveDemoIcon(icons, "bell")}
          </InertIcon>
        </span>
        <span className="relative inline-flex shrink-0">
          <DemoAvatar
            name={userName}
            size="sm"
            src={navigation?.userAvatar}
            tone="default"
          />
          {badge ? <span className="inbox-demo-plan-badge">{badge}</span> : null}
        </span>
      </div>
    </header>
  );
}
